
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["oeamtc-button__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 12.06a3.06 3.06 0 01-.1.7 4.71 4.71 0 01-.21.68 2.65 2.65 0 01-1.21 1.05 3.83 3.83 0 01-1.85.51 4.41 4.41 0 01-.52 0 5.58 5.58 0 01-.57-.13l-.48-.14-.55-.21-.51-.21a8.76 8.76 0 01-1.74-.82 15.76 15.76 0 01-2.63-2.14 15.76 15.76 0 01-2.12-2.63A8.76 8.76 0 011.69 7c0-.06-.08-.23-.18-.49l-.21-.57c0-.11-.08-.26-.14-.48A5.58 5.58 0 011 4.89a4.41 4.41 0 010-.52 3.83 3.83 0 01.51-1.85 2.65 2.65 0 011.05-1.21 4.71 4.71 0 01.68-.21 3.06 3.06 0 01.7-.1.51.51 0 01.21 0c.12 0 .3.29.53.76l.3.53c.12.23.24.44.35.63s.2.37.3.54l.18.24a4 4 0 01.19.39.58.58 0 01.07.28.82.82 0 01-.28.5 4.53 4.53 0 01-.62.54c-.22.17-.43.35-.62.53a.81.81 0 00-.28.46.74.74 0 000 .22 1.09 1.09 0 00.09.21l.13.24.12.18a10.3 10.3 0 001.8 2.34 10.3 10.3 0 002.34 1.73l.18.12.24.13.21.09a.74.74 0 00.22.05.81.81 0 00.46-.28c.18-.19.36-.4.53-.62a4.53 4.53 0 01.54-.62.82.82 0 01.5-.28.58.58 0 01.28.07l.36.21.24.18.54.3.63.35.53.3c.47.23.72.41.76.53a.51.51 0 01.03.21z"}})])
          )
        }
      }
    